import { Badge, Flex, Grid, Text } from "@mantine/core";
import { IResourceComponentsProps, useShow, HttpError } from "@refinedev/core";
import {
  Show,
  DeleteButton,
  EditButton,
  ListButton,
  RefreshButton,
} from "@refinedev/mantine";
import {
  DetailsCard,
  DetailsUserCard,
} from "components/common/show/DetailsPair";
import { History } from "components/common/show/History";
import { TeaAddonProblem } from "entities/tea_addon_problem";
import { format } from "date-fns";
import { useParams } from "react-router-dom";

export const SanityCheckersShow: React.FC<IResourceComponentsProps> = () => {
  const { id } = useParams();
  const { queryResult } = useShow<TeaAddonProblem, HttpError>({
    resource: "tea_addon_problems",
    id: id,
  });
  const { data, isLoading, isError } = queryResult;
  const problem = data?.data;

  if (isError) {
    return (
      <div>
        <Text color="red">
          Error loading problem. Please try again.
        </Text>
      </div>
    );
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!problem) {
    return <div>Problem not found</div>;
  }

  return (
    <Show
      isLoading={isLoading}
      resource="sanity_checkers"
      headerButtons={
        <Flex gap="sm">
          <ListButton resource="sanity_checkers" />
          <RefreshButton />
          <EditButton
            resource="sanity_checkers"
            recordItemId={problem.id}
          />
          <DeleteButton
            resource="tea_addon_problems"
            recordItemId={problem.id}
          />
        </Flex>
      }
    >
      <Grid>
        <Grid.Col span={8}>
          <Flex gap="sm" direction="column">
            <DetailsCard title="Notes">
              <Text>{problem.notes || "No notes"}</Text>
            </DetailsCard>
            {problem.id && (
              <History<TeaAddonProblem>
                resources={"tea_addon_problems"}
                entityId={problem.id}
              />
            )}
          </Flex>
        </Grid.Col>
        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <DetailsUserCard user={problem.user} />
            <DetailsCard title="ID">
              <Text>{problem.id}</Text>
            </DetailsCard>
            <DetailsCard title="Key">
              <Badge color="red" size="lg">
                {problem.key
                  .replace(/_/g, " ")
                  .replace(/([a-z])([A-Z])/g, "$1 $2")
                  .split(/\s+/)
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(" ")}
              </Badge>
            </DetailsCard>
            <DetailsCard title="State">
              <Badge
                color={problem.state === "fixed" ? "green" : problem.state === "fixing" ? "yellow" : "orange"}
                size="lg"
              >
                {problem.state}
              </Badge>
            </DetailsCard>
            {problem.sanity_checker && (
              <DetailsCard title="Sanity Checker ID">
                <Badge color="blue" variant="light" size="lg">
                  {problem.sanity_checker.id}
                </Badge>
              </DetailsCard>
            )}
            {problem.created_at && (
              <DetailsCard title="Created At">
                <Text>
                  {format(new Date(problem.created_at), "yyyy-MM-dd HH:mm:ss")}
                </Text>
              </DetailsCard>
            )}
          </Flex>
        </Grid.Col>
      </Grid>
    </Show>
  );
};

